<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-container" :class="{ 'modal-lg': modalSize == 'large', 'modal-sm': modalSize == 'small' }">
                <header>
                    <h3>{{ modalTitle }}</h3>
                    <button type="button" v-if="hasCloseHandler" class="btn btn-close" @click="close()"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                </header>

                <div class="modal-body">
                    <slot v-if="loaded">
                    </slot>
                    <div v-else class="text-center">
                        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                    </div>
                </div>
                <footer v-if="loaded && hasSaveHandler && !saveDisabled">
                    <button :disabled="saveDisabled" type="button" class="btn btn-custom" @click="save">
                        <i v-if="saved" class="fa fa-check fa-lg fa-fw" aria-hidden="true"></i>
                        <i v-else class="fa fa-circle-o-notch fa-spin fa-lg fa-fw" aria-hidden="true"></i>
                         Save
                    </button>
                    <div class="modal-errors">
                        <slot name="errors">
                        </slot>
                    </div>
                </footer>
            </div>
        </div>
    </transition>
</template>
<script>
var _ = require('lodash');

  export default {
    props: {
      modalTitle: {
        type: String
      },
      modalSize: {
        type: String,
        default: 'normal'
      },
      loaded: {
        type: Boolean,
        default: true
      },
      saved: {
        type: Boolean,
        default: true,
      },
      saveDisabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      hasSaveHandler: function () {
        return this.$listeners.save;
      },
      hasCloseHandler: function () {
        return this.$listeners.close;
      }
    },
    methods: {
      close: _.debounce(function() {
        this.$emit('close');
      }),
      save: _.debounce(function () {
        this.$emit('save');
      })
    }
  }
</script>
<style>
 .modal-errors {
     display: inline-block;
     margin-left: 1em;
     color: #960505;
 }
 .modal-container {
     display: flex;
 }
 .modal-lg .modal-body {
     height: 100vh;
 }
</style>



// WEBPACK FOOTER //
// BaseModal.vue?542501f5